import { FC, } from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Typography
} from '@material-ui/core';
import CheckCircleOutlineRoundedIcon from '@material-ui/icons/CheckCircleOutlineRounded';
import { format } from 'date-fns';
import { REPAIR_REQUEST_ID_PREFIX } from 'src/constants/repairRequest-constants';
import { E_WASTE_REQUEST_ID_PREFIX } from 'src/constants/eWaste-constants';
import { PLASTIC_REQUEST_ID_PREFIX, UCO_REQUEST_ID_PREFIX } from 'src/constants/common-constant';

interface RequestSuccessDialogProps {
  onClose: () => void;
  isSourceDrive?: boolean;
  requestId: string;
  appointmentDate: Date;
  appointmentSlot: string;
  customerName?: string;
  open: boolean;
}

export const RequestSuccessDialog: FC<RequestSuccessDialogProps> = (props) => {
  const { open, onClose, requestId, customerName,
    appointmentDate, appointmentSlot, isSourceDrive } = props;

  const onCloseDialog = (event, reason) => {
    if (reason !== 'backdropClick') {
      onClose();
    }
  };

  const getRequestType = (reqId) => {
    switch (true) {
      case reqId.startsWith(PLASTIC_REQUEST_ID_PREFIX):
        return 'Plastic Waste';
      case reqId.startsWith(REPAIR_REQUEST_ID_PREFIX):
        return 'Repair';
      case reqId.startsWith(UCO_REQUEST_ID_PREFIX):
        return 'UCO';
      case reqId.startsWith(E_WASTE_REQUEST_ID_PREFIX):
        return 'E-waste';
      default:
        return '';
    }
  };
  return (
    <Dialog
      onClose={onCloseDialog}
      open={open}
    >
      <Box
        sx={{ textAlign: 'center', mt: 2 }}
      >
        <CheckCircleOutlineRoundedIcon
          color="success"
          fontSize="large"
          sx={{ fontSize: '100px' }}
        />
        <DialogTitle
          sx={{
            pt: 0,
            pb: 0
          }}
        >
          <Typography
            color="inherit"
            sx={{ ml: 2 }}
            variant="body1"
          >
            {`Request ID: ${requestId}`}
          </Typography>
        </DialogTitle>
        <DialogContent>
          {!isSourceDrive ? (
            <Typography
              color="textPrimary"
              variant="h5"
            >
              {`${getRequestType(requestId)} request raised for ${customerName}`}
            </Typography>
          ) : (
            <Typography
              color="textPrimary"
              variant="h5"
            >
              {`${getRequestType(requestId)} Collected from ${customerName}`}
            </Typography>
          )}
          {!isSourceDrive && (
            <>
              <Typography
                color="textPrimary"
                variant="subtitle1"
              >
                {`Appointment Date ${requestId.startsWith(REPAIR_REQUEST_ID_PREFIX) ? '& Time' : ''}`}
              </Typography>
              <Typography
                variant="caption"
                display="block"
              >
                {`${format(appointmentDate, 'dd MMM, yyyy')} ${appointmentSlot || ''}`}
              </Typography>
            </>
          )}
          <Button
            variant="text"
            onClick={(e) => {
              onCloseDialog(e, '');
            }}
          >
            Done
          </Button>
        </DialogContent>
      </Box>
    </Dialog>
  );
};

RequestSuccessDialog.defaultProps = {
  open: false,
  isSourceDrive: false
};

RequestSuccessDialog.propTypes = {
  onClose: PropTypes.func,
  requestId: PropTypes.string,
  customerName: PropTypes.string,
  appointmentDate: PropTypes.instanceOf(Date),
  appointmentSlot: PropTypes.string,
  open: PropTypes.bool,
  isSourceDrive: PropTypes.bool
};
